var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 6.73907V5.59983C13.6 2.50723 11.0928 0 8.00019 0C4.90759 0 2.39998 2.50723 2.39998 5.6002V6.73945C0.943867 7.37469 0.00224998 8.81168 0 10.4002V15.2001C0.00262498 17.4081 1.79211 19.1976 4.00009 19.2002H11.9999C14.2079 19.1976 15.9974 17.4081 16 15.2001V10.4002C15.9981 8.81168 15.0561 7.37469 13.6 6.73945V6.73907ZM8.80006 13.6C8.80006 14.0418 8.44193 14.3999 8.00019 14.3999C7.55844 14.3999 7.20032 14.0418 7.20032 13.6V11.9999C7.20032 11.5582 7.55844 11.2 8.00019 11.2C8.44193 11.2 8.80006 11.5582 8.80006 11.9999V13.6ZM11.9999 6.40007H4.00009V5.6002C4.00009 3.3911 5.79108 1.60011 8.00019 1.60011C10.2093 1.60011 12.0003 3.3911 12.0003 5.6002V6.40007H11.9999Z",
    fill: "white",
    fillOpacity: 0.39
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandado);
export default __webpack_public_path__ + "static/media/candado.3985a1fa7c95ac5d924194078e331730.svg";
export { ForwardRef as ReactComponent };